<template>
    <div>
        <div type="success" size="mini" class="text-sm text-white margin-top bg-green"
             @click="showdown()"
             style="width: 60px;height: 21px;border-radius: 2px;"
        >下载</div>
        <el-dialog
                title="下载" class="fotoo"
                :visible.sync="dialogVisible"
                width="680" append-to-body
                :before-close="handleClose">
            <div class="downx-tips text-black" v-if="item.downloads>0">
                下载当前文件会消耗{{MG(item.fileSize)}}下载额度，确定下载吗？
            </div>
            <div class="downx-tips text-black" v-else="">
                本次下载不会扣除下载额度（打包已扣除额度）
            </div>
            <div class="flex align-center justify-end padding">
                <div class="text-sm text-gray line-gray solid cursor radius padding-sm padding-lr-xl"
                     @click="dialogVisible=false"
                >取消</div>
                <!--
                <a class="thunder-link" v-if="draftinfo.residualDownloadTraffic/1>item.fileSize/1"
                   :href="item.downloadUrl">
                    <div
                         @click="download(true)"
                         class="text-sm text-green line-green solid radius cursor padding-sm padding-lr-xl margin-left"
                    >迅雷下载</div>
                </a>
                -->
                <div class="text-sm text-white bg-green radius cursor padding-sm padding-lr-xl margin-left"
                     @click="download()"
                >确定下载</div>
            </div>
        </el-dialog>
        <dialogDownAll ref="dialogDownAll" :draftinfo="draftinfo"
                       :residueSize="draftinfo.residualDownloadTraffic/1"></dialogDownAll>
    </div>
</template>
<script>
  import App from '../../util/comfun'
  import thunder from '../../../static/js/thunder-link.js'
  import dialogDownAll from '../dialog/downAll.vue'
  export default {
    props:{
      item:{
        type:Object,
        value:{}
      },
      draftinfo: {
        type: Object,
        value: {},
      },
      identityType:{
        type:Number,
        value:-1,
      },
    },
    data () {
      return {
        dialogVisible: false,
      }
    },
    components:{
      dialogDownAll,
    },
    methods:{
      MG:App.MG,
      handleClose(done) {
        done();
      },
      showdown(){
        if(![0,1].includes(this.identityType)) {
          return this.$message({
            showClose: true,
            message: App.identityTypes(this.identityType)+'无操作权限',
            type: 'error',
          });
        }
        if(this.item.downloads/1>0 && this.item.fileSize/1 > this.draftinfo.residualDownloadTraffic/1){//剩余不足
          this.dialogVisible=false
          return this.$refs.dialogDownAll.showTotalSize(this.item.fileSize/1)
        }
        setTimeout(()=>{
          new window.thunderLink()
        },100)
        this.dialogVisible=true
      },
      download(hasThunderLink=false){
        let loading=this.$loading({text:'loading...',target: '.down-content',})
        App.demand('/download/queryDownloadUrl','GET',{
          downloadRecordId:this.item.id,
        }).then(res=>{
          setTimeout(()=>{loading.close();},0)
          if(res.code!=200){
            return this.$message({
              showClose: true,
              message: res.message||'出错了，请刷新页面后重试',
              type: 'error'
            });
          }
          this.$emit('event',{type:'download'})
          if(hasThunderLink) return;
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = res.data.replace('http://','https://')
          link.setAttribute('download', this.item.fileName)
          document.body.appendChild(link)
          //console.log('link',link)
          link.click()
          document.body.removeChild(link)
        })
      },
    },
    mounted(){

    },

  }
</script>

<style>
    .downx-tips{
        padding-left: 60px;
        height: 25px;
        opacity: 1;
        font-size: 14px;
        font-family: PingFang, PingFang-SC;
        font-weight: SC;
        text-align: left;
        line-height: 25px;
        padding-bottom: 12px;
        border-bottom: 1px solid #e0e0e0;
    }
</style>


// WEBPACK FOOTER //
// src/components/dialog/downx.vue